import React from 'react'
import { Alert, Button, Flex, Form, Spin } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import Dragger from 'antd/es/upload/Dragger'
import { useImportModelMutation } from '../../../../../../../store/apis/assignment.api'
import { openNotificationWithIcon } from '../../../../../../../utils/notification.helper'

const ImportModelForm = ({ onCancel }) => {
    const [importModel, importModelResult] = useImportModelMutation()
    const [form] = Form.useForm()

    const handleSubmit = async values => {
        const response = await importModel({ file: values.file })
        if ('data' in response) {
            const message = `Importing of the ${`<code>${values.file.name}</code>` || 'model'} has been started`
            openNotificationWithIcon('success', message)
            onCancel()
        }
        return false
    }

    const draggerProps = {
        name: 'file',
        accept: '.json, .zip',
        multiple: false,
        maxCount: 1,
        beforeUpload: () => false,
        listType: 'picture',
    }

    return (
        <Spin spinning={importModelResult?.isLoading}>
            <Form name='import' autoComplete='off' layout='vertical' form={form} onFinish={handleSubmit}>
                <Form.Item name='file' label='File' getValueFromEvent={event => event.file} rules={[{ required: true, message: 'Please, upload a file' }]}>
                    <Dragger {...draggerProps} aria-label='Submission files'>
                        <p className='ant-upload-drag-icon'>
                            <InboxOutlined />
                        </p>
                        <p className='ant-upload-text'>Click or drag file with exported model to this area</p>
                    </Dragger>
                </Form.Item>
                <Flex justify='end' align='end'>
                    <Form.Item>
                        <Button type='primary' htmlType='submit' block loading={importModelResult?.isLoading}>
                            Import
                        </Button>
                    </Form.Item>
                </Flex>
                {importModelResult.isError && (
                    <Alert message={importModelResult?.error} type='error' showIcon closable />
                )}
            </Form>
        </Spin>
    )
}

export default ImportModelForm
